export default __webpack_public_path__ + "static/media/logo.cecd3af2.svg";